function SecondaryButton({buttonText}) {
    return (
        <button type="button" className="secondary-button">
            {buttonText}
        </button>
    )
}

export default SecondaryButton;